import { useState, useEffect } from "react";
import Mower from "./Mower";
import { useDispatch, useSelector } from 'react-redux';
import { setOrderData } from "Store/Component/BulkOrder/BulkOrderAction";
import { commonDropDownSelectionChange } from "utils";

const MowerContainer = (props: any) => {
  const { vehicle, managedMowerRef } = props

  const dispatch = useDispatch();

  const [manufacturerDropDownList, setManufacturerDropDownList] = useState<any>([]);
  const [deckSizeDropDownList, setDeckSizeDropDownList] = useState<any>([]);
  const [deckTypeDropDownList, setDeckTypeDropDownList] = useState<any>([]);
  const [annualHoursDropDownList, setAnnualHoursDropDownList] = useState<any>([]);
  const [categoryDropdownList, setCategoryDropdownList] = useState<any>([]);
  const [stateAvailabilityDropDownList, setstateAvailabilityDropDownList] = useState<any>([]);
  const [programStatusDropDownList, setProgramStatusDropDownList] = useState<any>([]);
  const [autonomousDropDownList, setAutonomousDropDownList] = useState<any>([]);

  const { orderDetails }: any = useSelector((state?: any) => ({
    orderDetails: state.BulkOrderReducer.orderDetails
  }));

  ///Modified dropDown values as required
  useEffect(() => {
    let dropdownList:any =  vehicle?.searchDropdowns?.length ? JSON.parse(JSON.stringify(vehicle?.searchDropdowns)) : []
    if (dropdownList?.length > 0) {
      dropdownList?.map((item: any) => {
        if (item?.dropdownName == "Manufacturer") {
          const defaultManufacturerOption = {
            text: "Select Manufacturer",
            value: null
          };
          item?.dropdownList?.unshift(defaultManufacturerOption);
          let manufacturerDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ value: val.value, label: val.text, key: val.value })
          );
          setManufacturerDropDownList(manufacturerDropdownListTemp)
        } else if (item?.dropdownName == "Category") {
          const defaultManufacturerOption = {
            text: "Select Category",
            value: null
          };
          item?.dropdownList?.unshift(defaultManufacturerOption);
          let categoryDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ value: val.value, label: val.text, key: val.value })
          );
          setCategoryDropdownList(categoryDropdownListTemp)
        } else if (item?.dropdownName == "Deck Size") {
          const defaultManufacturerOption = {
            text: "Select Deck Size",
            value: null
          };
          item?.dropdownList?.unshift(defaultManufacturerOption);
          let deckSizeDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ value: val.value, label: val.text, key: val.value })
          );
          setDeckSizeDropDownList(deckSizeDropdownListTemp)
        } else if (item?.dropdownName == "Deck Type") {
          const defaultManufacturerOption = {
            text: "Select Deck Type",
            value: null
          };
          item?.dropdownList?.unshift(defaultManufacturerOption);
          let deckTypeDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ value: val.value, label: val.text, key: val.value })
          );
          setDeckTypeDropDownList(deckTypeDropdownListTemp)
        } else if (item?.dropdownName == "State Availability") {
          const defaultManufacturerOption = {
            text: "Select State Availability",
            value: null
          };
          item?.dropdownList?.unshift(defaultManufacturerOption);
          let stateAvailabilityDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ value: val.value, label: val.text, key: val.value })
          );
          setstateAvailabilityDropDownList(stateAvailabilityDropdownListTemp)
        } else if (item?.dropdownName == "Program Status") {
          const defaultManufacturerOption = {
            text: "Select Program Status",
            value: null
          };
          item?.dropdownList?.unshift(defaultManufacturerOption);
          let programStatusDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ value: val.value, label: val.text, key: val.value })
          );
          setProgramStatusDropDownList(programStatusDropdownListTemp)
        } else if (item?.dropdownName == "Annual Hours") {
          const defaultManufacturerOption = {
            text: "Select Annual Hours",
            value: null
          };
          item?.dropdownList?.unshift(defaultManufacturerOption);
          let annualHoursDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ value: val.value, label: val.text, key: val.value })
          );
          setAnnualHoursDropDownList(annualHoursDropdownListTemp)
        } else if (item?.dropdownName == "Autonomous") {
          const defaultManufacturerOption = {
            text: "Select Autonomous",
            value: null
          };
          item?.dropdownList?.unshift(defaultManufacturerOption);
          let autonomousDropdownListTemp = item?.dropdownList?.map((val: any) =>
            ({ value: val.value, label: val.text, key: val.value })
          );
          setAutonomousDropDownList(autonomousDropdownListTemp)
        }
      })
    }
  }, [vehicle?.searchDropdowns])

  const handleSelectionChange = (e: any, item: any, name: string, nextField: number) => {
    let globalValues = {
      orderDetails: orderDetails,
      vehicle: vehicle,
      dispatch: dispatch,
    }
    commonDropDownSelectionChange(item, name, nextField, globalValues, setOrderData, managedMowerRef)
  }

  useEffect(() => {
    managedMowerRef.current[1]?.focus()
  }, [])

  return (
    <Mower
      managedEquipmentValues={vehicle?.searchCriteria}
      manufacturerDropDownList={manufacturerDropDownList}
      categoryDropdownList={categoryDropdownList}
      deckSizeDropDownList={deckSizeDropDownList}
      deckTypeDropDownList={deckTypeDropDownList}
      stateAvailabilityDropDownList={stateAvailabilityDropDownList}
      annualHoursDropDownList={annualHoursDropDownList}
      autonomousDropDownList={autonomousDropDownList}
      programStatusDropDownList={programStatusDropDownList}
      managedMowerRef={managedMowerRef}
      handleSelectionChange={handleSelectionChange}
    />
  )
}

export default MowerContainer;
